// extracted by mini-css-extract-plugin
var _1 = "GfbhJELI";
var _2 = "GfbhJELI";
var _3 = "cfqWqDvy";
var _4 = "cfqWqDvy";
export { _1 as "sticker-container", _2 as "stickerContainer", _3 as "sustainable-container", _4 as "sustainableContainer" }
